import { Box, Image } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { useContext } from 'react'
import { UserContext } from '../../../providers'
import { PublicLinksInfoContext } from '../../../providers/PublicLinksInfoProvider'
import { ThreadAvatarOverlay } from '../Details/Threads'
import { PermissionsEnum, checkOperationPermission } from '../../../../utils'
import { ACLPermissionEnum } from '../../../constants'
import type { FileDetailsResponse, MediaLibrarySearchFileResponse } from '../../../interfaces'
import PermissionGuard from '../../PermissionGuard'
import LazyNewThreadPanel from '../Details/Threads/LazyNewThreadPanel'
import type { FilePreviewProps } from '.'

const TxtPreview = ({
  file,
  showThreads = false,
  showPreview = false,
}: FilePreviewProps): ReactElement => {
  const { isPublicLink } = useContext(PublicLinksInfoContext)
  const { url, thumbnail } = file
  const previewUrl = (file as FileDetailsResponse).previewUrl
  const { user } = useContext(UserContext)

  return (
    <Box position="relative" height="100%" width="100%">
      {showPreview ? (
        <iframe
          title="TXT File Preview"
          height="100%"
          width="100%"
          src={previewUrl ?? url}
        />
      ) : (
        <Image src={thumbnail} boxSize="100%" padding="0" />
      )}
      {showThreads && !isPublicLink ? (
        <>
          <PermissionGuard
            permission={PermissionsEnum.RESTRICTED_SELF_MEDIA_LIBRARY_MANAGE}
          >
            {(hasPermission: boolean) =>
              hasPermission &&
              checkOperationPermission({
                user,
                aclPermission: [
                  ACLPermissionEnum.CONTRIBUTE,
                  ACLPermissionEnum.MANAGE,
                ],
                selectedFiles: [file] as MediaLibrarySearchFileResponse[],
                selectedFolders: [],
                selectedMediaCollections: [],
              }) ? (
                <LazyNewThreadPanel
                  fileDetails={file}
                  position={null}
                  setThreadPanelPosition={() => {}}
                />
              ) : (
                <></>
              )
            }
          </PermissionGuard>
          <ThreadAvatarOverlay fileDetails={file} />
        </>
      ) : null}
    </Box>
  )
}

export default TxtPreview
